module.exports = __webpack_public_path__ + "img/exclusive_v1.c92a553.png";